import { useMemo } from 'react'
import { useGameStore } from '@/store/gameStore'
import { useCareerStore } from '@/store/careerStore'
import { useClaimableRewards } from './useClaimableRewards'

// A badge is either a dot (boolean) or a count (number). Zero/false render nothing.
export type BadgeValue = boolean | number

export interface NavBadges {
  '/dashboard': BadgeValue
  '/facilities': BadgeValue
  '/staff': BadgeValue
  '/services': BadgeValue
  '/economy': BadgeValue
  '/competitions': BadgeValue
  '/career': BadgeValue
  '/settings': BadgeValue
}

export function useNavBadges(): NavBadges {
  const courts = useGameStore(s => s.courts)
  const tournamentOffers = useGameStore(s => s.tournamentOffers)
  const activeEffects = useGameStore(s => s.activeEffects)
  const pendingLevelUp = useGameStore(s => s.pendingLevelUp)
  const pendingOffers = useCareerStore(s => s.pendingOffers)
  const { count: claimableRewards } = useClaimableRewards()

  return useMemo(() => {
    const lowCondition = courts.some(c => c.condition < 30)
    const hasTournamentOffers = tournamentOffers.length > 0
    const hasActiveEffects = activeEffects.length > 0

    return {
      '/dashboard': pendingLevelUp !== null,
      '/facilities': lowCondition,
      '/staff': false,
      '/services': false,
      '/economy': hasActiveEffects,
      '/competitions': hasTournamentOffers,
      // Claimable rewards (Metas) show as a count; club offers fall back to a dot.
      '/career': claimableRewards > 0 ? claimableRewards : pendingOffers.length > 0,
      '/settings': false,
    }
  }, [courts, tournamentOffers, activeEffects, pendingLevelUp, pendingOffers, claimableRewards])
}
